import {
  ChangeEvent,
  useRef,
  ReactNode,
} from 'react';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';

interface InputFileUploadProps {
  title: string;
  acceptedFiles: string;
  // eslint-disable-next-line no-unused-vars
  onFileLoaded: (data: any) => void;
  icon?: ReactNode;
  variant?: 'text' | 'outlined' | 'contained' | undefined;
  color?: 'inherit' | 'info' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | undefined;
}
function InputFileUpload({
  title,
  acceptedFiles,
  onFileLoaded,
  icon,
  variant,
  color,
}: InputFileUploadProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUpload = () => {
    if (inputRef) {
      const ref: any = inputRef.current;
      ref.click();
    }
  };

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target?.files;
    if (files && files.length > 0) {
      if (files[0]) {
        const file = files[0];
        const reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        // eslint-disable-next-line func-names
        reader.onload = function () {
          onFileLoaded(file);
          // eslint-disable-next-line no-param-reassign
          event.target.value = ''; // Allows to rerun everything if the same file is reuploaded
        };
        // eslint-disable-next-line func-names
        reader.onerror = function () {
          toast.error('Failed to read the uploaded file');
        };
      }
    }
  };

  return (
    <>
      <Button
        variant={variant}
        color={color}
        startIcon={icon ?? <CloudUploadIcon />}
        onClick={handleUpload}
        fullWidth
      >
        {title}
      </Button>
      <input
        type="file"
        name="upload-file"
        accept={acceptedFiles}
        style={{ display: 'none' }}
        ref={inputRef}
        onChange={changeHandler}
      />
    </>
  );
}

export default InputFileUpload;
